import React from 'react';
import { ValueButton, ValueText } from './Section';
import styles from '../molecules/section/Grid.module.scss';

type ValueListProps = {
  values: string[];
  onItemClick?: (value: string) => void;
};

const ValueList: React.FC<ValueListProps> = ({ values, onItemClick }) => {
  if (!values.length) {
    return (
      <ValueText
        label="-"
        kind="Text"
      />
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {values.map((value) =>
        onItemClick ? (
          <ValueButton
            key={value}
            label={value}
            onClick={() => onItemClick(value)}
            className={styles.linkButton}
          />
        ) : (
          <ValueText
            key={value}
            label={value}
            kind="Text"
          />
        ),
      )}
    </div>
  );
};

export default ValueList;